export const LIST = "/";
export const EDIT = "/:id/edit";
export const CREATE = "/create";
export const AUTHCOOKIENAME = "MallcommAuthCookie"